import { render, staticRenderFns } from "./medical-discount-view.vue?vue&type=template&id=48aaa3c0&scoped=true&"
import script from "./medical-discount-view.vue?vue&type=script&lang=js&"
export * from "./medical-discount-view.vue?vue&type=script&lang=js&"
import style0 from "./medical-discount-view.vue?vue&type=style&index=0&id=48aaa3c0&prod&lang=scss&scoped=true&"
import style1 from "./medical-discount-view.vue?vue&type=style&index=1&id=48aaa3c0&prod&lang=scss&scoped=true&"
import style2 from "./medical-discount-view.vue?vue&type=style&index=2&id=48aaa3c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aaa3c0",
  null
  
)

export default component.exports
import {QSkeleton,QSeparator,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton,QSeparator,QImg})
